// import React, { useEffect, useState } from 'react'
// import { useNavigate } from 'react-router-dom';

// const Introduction = () => {
//     const link_status = `${process.env.PUBLIC_URL}/custom-icons/link_status.png`;
//     const link = `${process.env.PUBLIC_URL}/custom-icons/link.png`;
//     const [imgWidth, setImgWidth] = useState("50%");
//     const [imgHeight, setImgHeight] = useState("auto");
//     const [divWidth, setDivWidth] = useState("35%")
//     const navigate = useNavigate()

//     useEffect(() => {
//         const handleResize = () => {
//             const windowWidth = window.innerWidth;
//             if (windowWidth <= 410) {
//                 setImgWidth("98%");
//                 setDivWidth("92%")
//             }
//             else if (windowWidth <= 475) {
//                 setImgWidth("100%");
//                 setDivWidth("92%")
//             } else if (windowWidth <= 575) {
//                 setImgWidth("62%");
//                 setDivWidth("90%")
//             } else if (windowWidth <= 650) {
//                 setImgWidth("60%");
//                 setDivWidth("85%")
//             } else if (window.innerWidth <= 775) {
//                 setImgWidth("56%");
//                 setDivWidth("65%")
//             } else if (window.innerWidth <= 875) {
//                 setImgWidth("52%");
//                 setDivWidth("55%")
//             } else if (windowWidth <= 1000) {
//                 setImgWidth("52%");
//                 setDivWidth("40%")
//             } else if (window.innerWidth <= 1100) {
//                 setImgWidth("52%");
//                 setDivWidth("40%")
//             } else if (windowWidth <= 1300) {
//                 setImgWidth("52%");
//                 setDivWidth("35%")
//             } else {
//                 setImgWidth("50%");
//                 setDivWidth("35%")
//             }
//         };

//         window.addEventListener("resize", handleResize);
//         handleResize();
//         // Cleanup function to remove event listener
//         return () => window.removeEventListener("resize", handleResize);
//     }, []);

//     const [open, setOpen] = useState(false);

//     const handleClickOpen = () => {
//         navigate("/")
//     };

//     const handleClose = () => {
//         setOpen(false);
//     };
//     return (

//         <div
//             style={{
//                 display: "flex",
//                 alignItems: "center",
//                 flexDirection: "column",
//                 height: "100svh",
//                 gap: "1rem",
//                 marginBottom: "0.5rem",
//             }}
//         >
//             <img
//                 src={link_status}
//                 style={{
//                     width: imgWidth,
//                     height: imgHeight,
//                     maxHeight: "70svh",
//                     objectFit: "contain",
//                 }}
//                 alt="Link Status"
//             />
//             <div
//                 style={{
//                     padding: "0rem 1.3rem 0rem 1.3rem",
//                     // boxShadow: "0 4px 20px rgba(0, 0, 0, 0.1)",
//                     borderRadius: "1px",
//                     width: divWidth,
//                     height: "185px",
//                     display: "flex",
//                     alignItems: "center",
//                     justifyContent: "center",
//                     // gap: "0.3rem",
//                     flexDirection: "column",
//                     position: "absolute",
//                     bottom: "0.3rem",
//                     marginBottom: "1rem"
//                 }}
//             >
//                 <p
//                     style={{
//                         fontWeight: "600",
//                         fontSize: "1.7rem",
//                         fontFamily: "Barlow Condensed",
//                         marginBottom: "0.5rem"
//                     }}
//                 >
//                     Inspection at ease
//                 </p>
//                 <p style={{ fontFamily: "'Montserrat', sans-serif", lineHeight: "20px", fontSize: "0.9rem", color: "grey", marginBottom: "2rem" }}>
//                     Quickly inspect the car and get the right insights
//                 </p>
//                 <button
//                     style={{
//                         display: "flex",
//                         alignItems: "center",
//                         justifyContent: "center",
//                         gap: "0.2rem",
//                         border: "1.5px solid #FF0083",
//                         padding: "0rem 1rem",
//                         backgroundColor: "#ff0083",
//                         borderRadius: "3px",
//                         opacity: "0.9",
//                         width: "100%"
//                     }}
//                     onClick={handleClickOpen}
//                 >
//                     <p
//                         style={{
//                             fontSize: "0.9rem",
//                             fontFamily: "'Montserrat', sans-serif",
//                             color: "#FFFFFF",
//                             padding: "0.5rem",
//                             cursor: "pointer"
//                         }}

//                     >
//                         Continue
//                     </p>
//                 </button>
//             </div>
//         </div>
//     );
// }

// export default Introduction
import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import Support from "../contact-popup-module/Support"; // Assuming this is your introduction component

const Introduction = () => {
    const splashImage = `${process.env.PUBLIC_URL}/custom-icons/splash_image.png`; 
    const link_status = `${process.env.PUBLIC_URL}/custom-icons/link_status.png`;
    const link = `${process.env.PUBLIC_URL}/custom-icons/link.png`;

    const [showSplash, setShowSplash] = useState(true); 
    const [imgWidth, setImgWidth] = useState("50%");
    const [imgHeight, setImgHeight] = useState("auto");
    const [divWidth, setDivWidth] = useState("35%");
    const navigate = useNavigate();

    useEffect(() => {
        const splashTimeout = setTimeout(() => {
            setShowSplash(false);
        }, 4000); 

        const handleResize = () => {
            const windowWidth = window.innerWidth;
            if (windowWidth <= 410) {
                setImgWidth("98%");
                setDivWidth("92%");
            } else if (windowWidth <= 475) {
                setImgWidth("100%");
                setDivWidth("92%");
            } else if (windowWidth <= 575) {
                setImgWidth("62%");
                setDivWidth("90%");
            } else if (windowWidth <= 650) {
                setImgWidth("60%");
                setDivWidth("85%");
            } else if (window.innerWidth <= 775) {
                setImgWidth("56%");
                setDivWidth("65%");
            } else if (window.innerWidth <= 875) {
                setImgWidth("52%");
                setDivWidth("55%");
            } else if (windowWidth <= 1000) {
                setImgWidth("52%");
                setDivWidth("40%");
            } else if (window.innerWidth <= 1100) {
                setImgWidth("52%");
                setDivWidth("40%");
            } else if (windowWidth <= 1300) {
                setImgWidth("52%");
                setDivWidth("35%");
            } else {
                setImgWidth("50%");
                setDivWidth("35%");
            }
        };

        window.addEventListener("resize", handleResize);
        handleResize();

        return () => {
            clearTimeout(splashTimeout);
            window.removeEventListener("resize", handleResize);
        };
    }, []);

    const handleClickOpen = () => {
        navigate("/userType"); 
    };

    if (showSplash) {
        // Splash screen
        return (
            <div
                style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    height: "100svh",
                    backgroundColor: "#ff0083"
                }}
            >
                <img
                    src={splashImage} // Replace this with your splash screen image path
                    alt="Splash Screen"
                    style={{ width: "50%", height: "auto" }}
                />
            </div>
        );
    }

    return (
        <div
            style={{
                display: "flex",
                alignItems: "center",
                flexDirection: "column",
                height: "100svh",
                gap: "1rem",
                marginBottom: "0.5rem",
            }}
        >
            <img
                src={link_status}
                style={{
                    width: imgWidth,
                    height: imgHeight,
                    maxHeight: "70svh",
                    objectFit: "contain",
                }}
                alt="Link Status"
            />
            <div
                style={{
                    padding: "0rem 1.3rem 0rem 1.3rem",
                    borderRadius: "1px",
                    width: divWidth,
                    height: "185px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    flexDirection: "column",
                    position: "absolute",
                    bottom: "0.3rem",
                    marginBottom: "1rem"
                }}
            >
                <p
                    style={{
                        fontWeight: "600",
                        fontSize: "1.7rem",
                        fontFamily: "Barlow Condensed",
                        marginBottom: "0.5rem"
                    }}
                >
                    Inspection at ease
                </p>
                <p style={{ fontFamily: "'Montserrat', sans-serif", lineHeight: "20px", fontSize: "0.9rem", color: "grey", marginBottom: "2rem" }}>
                    Quickly inspect the car and get the right insights
                </p>
                <button
                    style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        gap: "0.2rem",
                        border: "1.5px solid #FF0083",
                        padding: "0rem 1rem",
                        backgroundColor: "#ff0083",
                        borderRadius: "3px",
                        opacity: "0.9",
                        width: "100%"
                    }}
                    onClick={handleClickOpen}
                >
                    <p
                        style={{
                            fontSize: "0.9rem",
                            fontFamily: "'Montserrat', sans-serif",
                            color: "#FFFFFF",
                            padding: "0.5rem",
                            cursor: "pointer"
                        }}
                    >
                        Continue
                    </p>
                </button>
            </div>
        </div>
    );
};

export default Introduction;
